import React from 'react';
import { Link } from 'react-router-dom';

function Unauthorized() {
    return (
        <div className="page unauthorized-page">
            <section className="panel unauthorized-panel">
                <span className="page-eyebrow">Access denied</span>
                <h1>You do not have access to this area</h1>
                <p className="page-subtitle">
                    Admin pages are restricted to authorized accounts only.
                </p>
                <div className="hero-actions">
                    <Link to="/app" className="btn btn-primary">Go to workspace</Link>
                    <Link to="/profile" className="btn btn-secondary">Open profile</Link>
                </div>
            </section>
        </div>
    );
}

export default Unauthorized;
